// extracted by mini-css-extract-plugin
export default {"slider":"slider_slider__IXIk0","vertical":"slider_vertical__74JR6","blue":"slider_blue__vj9f+","red":"slider_red__YGFeS"};